import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbtack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThumbtack"><Path d="M6.5 2V6.99695C6.5 8.65455 5.84152 10.2443 4.66942 11.4164L4 12.0858V16H11V22H13V16H20V12.0858L19.3306 11.4164C18.1585 10.2443 17.5 8.65455 17.5 6.99695V2H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbtack;
